/**
 * <SatisfactionCard> — the student-satisfaction block (molecule, L0.1).
 *
 * Mirrors the legacy satisfaction box: a card asking "Qu'a pensé {name} de cette session LIVE ?" over
 * a readonly `<Satisfaction>` star rating. The template renders it only for happy sessions
 * (`showSamCalendlyCta && satisfaction ≥ 5`). Composes DS atoms/molecules — `<Card>`, `<Title>`, `<Satisfaction>`.
 */
import React from "react"

import { Card } from "../Card"
import { Stack } from "../../atoms/containers/Stack"
import { Title } from "../../atoms/typography/Title"
import { Satisfaction } from "../../atoms/Satisfaction"

export type SatisfactionCardProps = {
    studentDisplayName: string
    rating: number
    testID?: string
}

export function SatisfactionCard(props: SatisfactionCardProps) {
    const { studentDisplayName, rating, testID } = props

    return (
        <Card p="5" testID={testID}>
            <Stack gap="4" align="center">
                <Title center size="text-xl">
                    Qu&apos;a pensé {studentDisplayName} de cette session LIVE ?
                </Title>
                <Satisfaction rating={rating} />
            </Stack>
        </Card>
    )
}
